import moment from "moment";
import strtotime from "locutus/php/datetime/strtotime";

export const quarters = (date) => {
    const ret = [];
    let currentQuarter = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentQuarterYear = currentQuarter.format("YYYY");
    currentQuarter = currentQuarter.quarter();
    [1,2,3,4].map((quarter) => {
        ret.push({type: "quarter", value: quarter, name: quarter + ". negyedév", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).endOf('quarter').format("YYYY-MM-DD")});
        if (currentYear === currentQuarterYear && currentQuarter === quarter) {
            ret.push({type: "quarter", currentTime: true, value: quarter, name: quarter + ". negyedév (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")});
        }
    });
    return ret;
}

export const halfyears = (date) => {
    const ret = [];
    let currentQuarter = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentQuarterYear = currentQuarter.format("YYYY");
    currentQuarter = currentQuarter.quarter();
    ret.push({type: "half", value: 1, name: "1. fél év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(2).endOf('quarter').format("YYYY-MM-DD")});
    if (currentYear === currentQuarterYear && [1,2].indexOf(currentQuarter) !== -1) {
        ret.push({type: "half", currentTime: true, value: 1, name: "1. fél év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")})
    }
    ret.push({type: "half", value: 2, name: "2. fél év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(3).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(4).endOf('quarter').format("YYYY-MM-DD")});
    if (currentYear === currentQuarterYear && [3,4].indexOf(currentQuarter) !== -1) {
        ret.push({type: "half", currentTime: true, value: 2, name: "2. fél év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(3).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")})
    }
    return ret;
}

export const months = (date) => {

    const ret = [];
    let currentMonth = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentMonthYear = currentMonth.format("YYYY");
    currentMonth = currentMonth.month();

    [0,1,2,3,4,5,6,7,8,9,10,11].map((month) => {
        ret.push({type: "month", value: month, name: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).format("MMMM"), from: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).startOf("month").format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).endOf("month").format("YYYY-MM-DD")});
        if (currentYear === currentMonthYear && month === currentMonth) {
            ret.push({type: "month", currentTime: true, value: month, name: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).format("MMMM") + " (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).startOf("month").format("YYYY-MM-DD"), to: moment().endOf("day").format("YYYY-MM-DD")});
        }
    });
    return ret;
}

export const fullyear = (date) => {
    const ret = [{type: "year", value: moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY"), name: "teljes év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(4).endOf('quarter').format("YYYY-MM-DD")}];
    if (moment().format("YYYY") === moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY")) {
        ret.push({type: "year", currentTime: true, value: moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY"), name: "teljes év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(4).endOf('quarter').format("YYYY-MM-DD")});
    }
    return ret;
}

export const ifCompletedInput = (event) => {
    if ([27].indexOf(event.which) !== -1) {
        event.preventDefault();
        return false;
    }
    if ([13, 9, 38, 40].indexOf(event.which) !== -1) {
        event.preventDefault();
        return true;
    }
    return false;
}

// https://gist.github.com/ralphcrisostomo/3141412
export const compressArray = (original) => {

    const compressed = [];
    // make a copy of the input array
    let copy = original.slice(0);

    // first loop goes over every element
    let i = 0;
    for (; i < original.length; i++) {

        let myCount = 0;
        // loop over every element in the copy and see if it's the same
        let w = 0;
        for (; w < copy.length; w++) {
            if (original[i] + "" === "" + copy[w]) {
                // increase amount of times duplicate is found
                myCount++;
                // sets item to undefined
                delete copy[w];
            }
        }

        if (myCount > 0) {
            let a = {};
            a.value = original[i];
            a.count = myCount;
            compressed.push(a);
        }
    }

    return compressed;
};

export const calcClassName = ({current, amount, total}) => {
    const counts = compressArray([current, amount, total]);
    const ret = {};
    Object.keys(counts).map((key) => {
        if (counts[key].value + "" === "" + current) {
            ret.current = counts[key].count;
        }
        if (counts[key].value + "" === "" + amount) {
            ret.amount = counts[key].count;
        }
        if (counts[key].value + "" === "" + total) {
            ret.total = counts[key].count;
        }
    });
    return ret;
}


// https://github.com/sumia01/js-forint-kerekites
export const hufRound = (x) => {
    if (x > 0) {
        return (x % 5) >= 2.5 ? parseInt(x / 5) * 5 + 5 : parseInt(x / 5) * 5;
    } else {
        return ((Math.abs(x) % 5) >= 2.5 ? parseInt(Math.abs(x) / 5) * 5 + 5 : parseInt(Math.abs(x) / 5) * 5)*-1;
    }
};

// https://gist.github.com/wesleybliss/432f9a63015736b99ee5751646e3e956
export const stringify = (someObject) => {
    let cache = [];
    const o = JSON.stringify(someObject, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return
            }
            // Store value in our collection
            cache.push(value)
        }
        return value
    });
    cache = null; // GC
    return o
};

export const isTrue = (value) => {
    return value === 1 || value === "1" || value === true || value === "true" || (Array.isArray(value) ? value.length > 0 : false) || (value instanceof Object ? Object.keys(value).length > 0 : false);
}

export const isFalse = (value) => {
    return value === '' || value === undefined || value === 0 || value === "0" || value === false || value === "false" || (Array.isArray(value) ? value.length === 0 : false) || (value instanceof Object ? Object.keys(value).length === 0 : (value === null));
}

export const isEmpty = (value) => {
    return isFalse(value);
}

export const noop = () => {};

export const delay = n => new Promise(resolve => setTimeout(resolve, n));

export const cancellablePromise = promise => {
    let isCanceled = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            value => (isCanceled ? reject({ isCanceled, value }) : resolve(value)),
            error => reject({ isCanceled, error }),
        );
    });

    wrappedPromise.cancel = () => (isCanceled = true);

    return wrappedPromise;
};

export const mergeFieldProps = function () {
    let props = {};
    const args = [].slice.call(arguments);
    args.map((arg) => {
        arg.disabled = props.disabled || arg.disabled;
        if (arg) {
            props = {...props, ...arg};
        }
    })
    return props;
}

export const isChristmas = (week = false) => {
    let date = new Date();
    let month = date.getMonth();
    let day = date.getDate();
    if (week && month === 11 && day > 20 && day < 30) return true;
    if (month === 11 && day === 25) return true; // Eleven because computers start counting @ 0
    return false;
}

export const stringToDate = (value) => {
    if (value) {
        value = value.toLowerCase().trim();
        if ((value.indexOf("+") === 0 || value.indexOf("-") === 0) && new RegExp(["nap", "hónap", "év"].join("|")).test(value)) {
            let type = 'days';
            switch (value.replace(/[\-0-9]/g, '').trim()) {
                case "nap":
                    type = "days";
                    break;
                case "hónap":
                    type = "months";
                    break;
                case "év":
                    type = "years";
                    break;
            }
            value = moment().add(value.replace(/[^\-0-9]/g, ''), type).toDate();
            return value;
        } else if (value === "holnap") {
            value = moment().add(1, 'days').toDate();
            return value;
        } else if (value === "ma") {
            value = moment().toDate();
            return value;
        } else if (value === "tegnap") {
            value = moment().add(-1, 'days').toDate();
            return value;
        } else {
            return new Date(strtotime(value) * 1000);
            //return moment(value, "YYYY-MM-DD HH:mm:ss").toDate();
        }
    }
    return null;
}